// The audience slider's scale. It runs from 1 to 5,000 guests, and a
// linear track that long leaves the jobs most Customers have — 50 to 300
// — in the first twentieth of it, so the track is logarithmic: every
// tenfold rise takes the same length of track. Above the top they type an
// exact number instead.

export const ATTENDANCE_MIN = 1;
export const ATTENDANCE_MAX = 5000;
/** Where the thumb rests before anything is answered. */
export const ATTENDANCE_REST = 100;

/** The track's own units: 0 at ATTENDANCE_MIN, POSITIONS at ATTENDANCE_MAX. */
export const POSITIONS = 1000;

const SPAN = Math.log(ATTENDANCE_MAX / ATTENDANCE_MIN);

/**
 * The guest count at a track position, rounded the way a person says a
 * crowd: to one below 100, to ten below 1,000, and to fifty above.
 */
export function attendanceAt(position: number): number {
  const p = Math.min(Math.max(position, 0), POSITIONS);
  const raw = ATTENDANCE_MIN * Math.exp((p / POSITIONS) * SPAN);
  const unit = raw < 100 ? 1 : raw < 1000 ? 10 : 50;
  return Math.min(Math.max(Math.round(raw / unit) * unit, ATTENDANCE_MIN), ATTENDANCE_MAX);
}

/** The track position of a guest count, pinned to the track's ends. */
export function positionOf(attendance: number): number {
  const a = Math.min(Math.max(attendance, ATTENDANCE_MIN), ATTENDANCE_MAX);
  return Math.round((Math.log(a / ATTENDANCE_MIN) / SPAN) * POSITIONS);
}
